import React from 'react';
import { LoginTemplate } from '../../templates';

const Login = ({ location }: any) => <LoginTemplate location={location} />;

export default Login;
